/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserProfileDeviceReport } from '../../models/user-profile-device-report';

export interface ReportUserProfileListGet$Params {
  organizationId?: string;
}

export function reportUserProfileListGet(http: HttpClient, rootUrl: string, params?: ReportUserProfileListGet$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<Array<UserProfileDeviceReport>>> {
  const rb = new RequestBuilder(rootUrl, reportUserProfileListGet.PATH, 'get');
  if (params) {
    rb.query('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<Array<UserProfileDeviceReport>>;
    })
  );
}

reportUserProfileListGet.PATH = '/Report/UserProfileList';
